'use client'

import Link from 'next/link'
import { useConsent } from '@/lib/consent'
import { CookieSettingsModal } from './cookie-settings-modal'

// Cookie banner -- corner card pattern (see higglo.io reference).
// Pinned bottom-left on desktop and tablet, full-width bottom on
// mobile. Dark surface, lime accent text, two primary actions plus a
// quiet "Customize" link for granular control.

export function CookieBanner() {
  const { hasDecided, acceptAll, rejectAll, openSettings, settingsOpen } = useConsent()

  if (hasDecided && !settingsOpen) return null

  return (
    <>
      {!hasDecided && (
        <div
          role="region"
          aria-label="Cookie consent"
          className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:bottom-5 sm:left-5 sm:max-w-sm"
        >
          <div className="rounded-2xl bg-[#0a0a0a] p-5 text-white shadow-2xl shadow-black/40 ring-1 ring-white/10">
            <p className="font-display text-base font-semibold tracking-tight">We use cookies</p>
            <p className="mt-2 text-[13px] leading-relaxed text-white/70">
              We use essential cookies to run this site and optional analytics cookies to understand how it&rsquo;s used. You can change your choice anytime in our{' '}
              <Link
                href="/privacy-policy"
                className="text-brand-lime underline underline-offset-2 transition hover:text-[#b3f53a]"
              >
                privacy policy
              </Link>
              .
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={acceptAll}
                className="inline-flex h-9 items-center rounded-full bg-white px-4 text-xs font-semibold text-[#0a0a0a] transition hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
              >
                Accept all
              </button>
              <button
                type="button"
                onClick={rejectAll}
                className="inline-flex h-9 items-center rounded-full border border-white/25 bg-transparent px-4 text-xs font-semibold text-white transition hover:border-white/45 hover:bg-white/[0.06] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
              >
                Essential only
              </button>
              <button
                type="button"
                onClick={openSettings}
                className="ml-auto text-[11px] font-medium text-white/75 underline-offset-2 transition hover:text-white hover:underline focus-visible:underline focus-visible:outline-none"
              >
                Customize
              </button>
            </div>
          </div>
        </div>
      )}
      <CookieSettingsModal />
    </>
  )
}
